export function useAsset(path: string): string {
    const assets = import.meta.glob('~/assets/img/*', {
        eager: true,
        import: 'default',
    })
    return assets[path]
}